export interface Loader {
  error: boolean;
  initial: boolean;
  loading: boolean;
  success: boolean;
  cancelled: boolean;
}

export type DataLoader<D = undefined, E = boolean> = Omit<Loader, 'error'> & {
  data: D | undefined;
  error: E | boolean;
};

const statuses: Loader = {
  initial: false,
  loading: false,
  success: false,
  error: false,
  cancelled: false,
};

const getInitial = (): Loader => ({ ...statuses, initial: true });
const getBegin = (): Loader => ({ ...statuses, loading: true });
const getSuccess = (): Loader => ({ ...statuses, success: true });
const getError = (error = true): Loader => ({ ...statuses, error });
const getCancelled = (): Loader => ({ ...statuses, cancelled: true });

export const withData = {
  initial: <D = undefined>(data: D | undefined = undefined): DataLoader<D> => {
    return {
      ...getInitial(),
      data,
    };
  },
  begin: <D = undefined>(data: D | undefined = undefined): DataLoader<D> => {
    return {
      ...getBegin(),
      data,
    };
  },
  success: <D>(data: D): DataLoader<D> => {
    return {
      ...getSuccess(),
      data,
    };
  },
  error: <E = boolean>(error: E | boolean = true): DataLoader<undefined, E> => {
    return {
      ...statuses,
      error,
      data: undefined,
    };
  },
};

export default {
  initial: getInitial,
  begin: getBegin,
  success: getSuccess,
  error: getError,
  cancelled: getCancelled,
  withData,
};
